module.exports = __webpack_public_path__ + "img/4.aaf89a93.jpg";